var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from "@discovery/common-dplus/lib/hooks";
import { getUrlParameter } from "../../../../utils/common";
import { clientInformation } from "@discovery/common-dplus/lib/device-info";
import { envBrowser } from "@discovery/maestro-env-browser";
import * as E from "fp-ts/Either";
import * as App from "@discovery/maestro";
import { AllAccessLandingPage } from "../parental-lock-first-flow/allAccessLandingPage";
import { CreatePin } from "../parental-lock-first-flow/create-pin-flow";
import { SecurityQuestionCard } from "./setSecurityQuestions";
import { Sucess } from "./sucess";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _Config } from "@discovery/common-dplus/lib/state";
import * as User from "@discovery/sonic-api-ng/lib/api/users/me";
import * as RecentSearch from "@discovery/sonic-api-ng/lib/api/users/custom-attributes";
import * as Profile from "@discovery/sonic-api-ng/lib/api/users/profiles";
import { ParentalLock } from "./parentalLock";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { navigateTo } from "../../../../utils/common";
import * as M from "@discovery/prelude/lib/data/maybe";
import { optional, record, string, } from "@discovery/prelude/lib/data/validated";
import { _CustomAttribute2Attributes } from "../../../../component-creators/optics";
import { _UserProfile } from "../../../../component-creators/hamburger/optics";
import { useUser } from "../../../../utils/hooks/useUser";
import Strings from "../../../../utils/hardcoded.json";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
const AllAccess = ({ route, nativeUrl, toggleAllAccess, read, userProfileLength, timeOut, onBackHandlerAfterTimeLock, timeLockVisibilityEvent, hideAllAccessPopup, allowAllAccess, showAllAccessAfterTimeLock, }) => {
    const { userId } = useUser();
    const [configM] = useGlobalState(_Config);
    const configUserAttributesM = M.chain((x) => x.userAttributes, configM);
    const parentalLockKeyCustomAttributeM = M.chain((x) => x.parentalLock, configUserAttributesM);
    const parentalLockKeyCustomAttribute = M.fromMaybe(parentalLockKeyCustomAttributeM, "");
    const [pathName, setPathName] = useState("");
    const [pin, setPinHash256] = useState("");
    const [, setRecoveryq1256] = useState("");
    const [, setRecoverySecondq256] = useState("");
    const [pinValidation, setPinValidation] = useState("");
    const [isAllAccess, setIsAllAcess] = useState(false);
    const [recoveryq1CustomAttr, setRecoveryq1CustomAttr] = useState("");
    const [recoveryq2CustomAttr, setRecoveryq2CustomAttr] = useState("");
    const [access, setAccess] = useState("");
    const setQueryParam = (queryParams, q, key) => {
        const url = window.location.href;
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("allAccess", key);
        const newParams = searchParams.toString();
        const queryString = url.indexOf("?") ? newParams : queryParams;
        const newurl = window.location.pathname + `${"?" + queryString}`;
        window.history.pushState({ path: newurl }, "", newurl);
        const pathName = getUrlParameter(q);
        pathName && setPathName(pathName);
    };
    const checkRoute = () => {
        const url = window.location.href;
        const pathUrl = new URL(url);
        const route = pathUrl.searchParams.get("allAccess");
        if (route === null)
            toggleAllAccess && toggleAllAccess();
    };
    const watchQueryParams = () => {
        const pathName = getUrlParameter("allAccess");
        checkRoute();
        pathName && setPathName(pathName);
    };
    const getParentalLockCustomAttributes = () => __awaiter(void 0, void 0, void 0, function* () {
        const endpoint = RecentSearch.Endpoints.getGenericCustomAttributes(parentalLockKeyCustomAttribute);
        yield App.run(endpoint)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
            /* handle exception here */
        }, (response) => {
            const parentalLockAttributesM = Fold.preview(_CustomAttribute2Attributes, response);
            const parentalLockAttributes = M.fromMaybe(parentalLockAttributesM, {});
            if (parentalLockAttributes &&
                parentalLockAttributes.parentalLock &&
                parentalLockAttributes.parentalLock.pin) {
                setPinValidation(parentalLockAttributes.parentalLock.pin);
                setRecoveryq1CustomAttr(parentalLockAttributes.parentalLock.recoveryResponse1);
                setRecoveryq2CustomAttr(parentalLockAttributes.parentalLock.recoveryResponse2);
                setIsAllAcess(true);
                setAccess("parentalLock");
            }
            else {
                setIsAllAcess(false);
                setAccess("kids");
            }
        }));
    });
    useEffect(() => {
        if (userProfileLength && userProfileLength > 1) {
            getParentalLockCustomAttributes();
        }
        else {
            setIsAllAcess(false);
            setAccess("kids");
        }
        window.addEventListener("popstate", watchQueryParams);
        return function cleanUp() {
            window.removeEventListener("popstate", watchQueryParams);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onContinue = (step) => {
        switch (step) {
            case "step1":
                return setQueryParam("allAccess=createPin", "allAccess", "createPin");
            case "step2":
                return setQueryParam("allAccess=recoveryQ", "allAccess", "recoveryQ");
            case "step3":
                return setQueryParam("allAccess=success", "allAccess", "success");
        }
    };
    const createPinHandler = (id) => {
        setPinHash256(id);
        onContinue("step2");
    };
    const switchUserProfileToAllAccess = (selectedProfileId) => __awaiter(void 0, void 0, void 0, function* () {
        if (read && userId) {
            const endpoint = User.Endpoints.patchMe(userId, selectedProfileId);
            yield App.run(endpoint)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
                /* handle exception here */
            }, () => {
                sessionStorage.setItem("pA", "true");
                try {
                    localStorage.setItem("isAllAccess", "true");
                }
                catch (e) {
                    console.info(e);
                }
            }));
        }
    });
    const createAllAccessProfile = () => __awaiter(void 0, void 0, void 0, function* () {
        if (read) {
            const endpoint = Profile.Endpoints.postProfile({
                profileName: "all-access",
                ageRestricted: false,
            });
            yield App.run(endpoint)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
                /* handle exception here */
            }, (response) => {
                const userProfileM = Fold.preview(_UserProfile, response);
                const userProfile = M.fromMaybe(userProfileM, []);
                switchUserProfileToAllAccess({
                    selectedProfileId: userProfile.id,
                });
            }));
        }
    });
    const postParentalLockCustomAttr = (pin, recoveryResponse1, recoveryResponse2) => {
        const customAttrValidator = optional(record({
            pin: string,
            recoveryResponse1: string,
            recoveryResponse2: string,
        }));
        const postCustomAttributesReq = {
            parentalLock: { pin, recoveryResponse1, recoveryResponse2 },
        };
        const postRequest = RecentSearch.Endpoints.putCustomAttributes(parentalLockKeyCustomAttribute, postCustomAttributesReq, customAttrValidator);
        App.run(postRequest)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
            /* handle exception here */
        }, () => {
            createAllAccessProfile();
        }));
    };
    const recoveryQuestionHandler = (answer1, answer2) => {
        setRecoveryq1256(answer1);
        setRecoverySecondq256(answer2);
        postParentalLockCustomAttr(pin, answer1, answer2);
        onContinue("step3");
    };
    const goBack = () => {
        window.history.back();
    };
    const onSuccess = () => {
        if (nativeUrl) {
            navigateTo(nativeUrl);
        }
        else {
            navigateTo(config.standardPageRouteFragments.allAccess);
        }
    };
    const renderPages = (route) => {
        switch (pathName.length > 0 ? pathName : route) {
            case "landing":
                return (React.createElement(AllAccessLandingPage, { onContinue: () => onContinue("step1"), nativeUrl: nativeUrl, isAllAccess: isAllAccess, userProfileLength: userProfileLength && userProfileLength, hideAllAccessPopup: hideAllAccessPopup }));
            case "createPin":
                return (React.createElement(CreatePin, { onContinue: (id) => createPinHandler(id), header: Strings.CREATE_PIN, pinlabel: Strings.YOUR_PIN, confirmPinLabel: Strings.CONFIRM_YOUR_PIN, onBack: goBack, label: Strings.ALL_ACCESS }));
            case "recoveryQ":
                return (React.createElement(SecurityQuestionCard, { header: Strings.PIN_RECOVERY_QUESTIONS, subHeader: Strings.SECURITY_ANSWER, onContinue: recoveryQuestionHandler, onBack: goBack, label: Strings.ALL_ACCESS, flow: "firstFlow" }));
            case "success":
                return React.createElement(Sucess, { onContinue: onSuccess });
            default:
                return;
        }
    };
    const renderUi = () => {
        if (access === "parentalLock") {
            return (React.createElement(ParentalLock, { route: route, pinValidation: pinValidation, read: read, userId: userId, nativeUrl: nativeUrl, recoveryq1CustomAttr: recoveryq1CustomAttr, recoveryq2CustomAttr: recoveryq2CustomAttr, userProfileLength: userProfileLength, isAllAccess: isAllAccess, timeOut: timeOut, onBackHandlerAfterTimeLock: onBackHandlerAfterTimeLock, timeLockVisibilityEvent: timeLockVisibilityEvent, hideAllAccessPopup: hideAllAccessPopup, parentalLockKeyCustomAttribute: parentalLockKeyCustomAttribute, allowAllAccess: allowAllAccess, showAllAccessAfterTimeLock: showAllAccessAfterTimeLock }));
        }
        else {
            return renderPages(route);
        }
    };
    return React.createElement(React.Fragment, null, renderUi());
};
export default AllAccess;

